import { color, font } from 'utils/styles';
import styled from 'styled-components';

export const AttachmentTitle = styled.div`
  color: ${color.textMedium};
  ${font.size(12.5)}
  ${font.bold}
`;
